import { Injectable } from '@angular/core';
import { SetInitialStateFacade } from '../../../../common/models';
import { CatalogSearchCriteriaFacade, CatalogSearchCriteriaType } from '../../catalog-search-criteria';
import { LoadCatalogFacade } from './load/catalog/load-catalog.facade';
import { TransportOrderCatalogFacade } from './transport-order/catalog/transport-order-catalog.facade';
import { TransportCatalogSearchCriteria } from './models';
import { TransportOrderCatalogStateModel } from './transport-order/catalog/transport-order-catalog.state';
import { BehaviorSubject, Observable } from 'rxjs';
import { LoadCatalogStateModel } from './load/catalog/load-catalog.state';
import { ListViewMode } from '../constants';

@Injectable({ providedIn: 'root' })
export class TransportCatalogFacade implements SetInitialStateFacade {
  activeState$: BehaviorSubject<Observable<TransportOrderCatalogStateModel | LoadCatalogStateModel>> =
    new BehaviorSubject(this.transportOrderCatalogFacade.listDto$);

  constructor(
    private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade,
    private loadCatalogFacade: LoadCatalogFacade,
    private transportOrderCatalogFacade: TransportOrderCatalogFacade,
  ) {}

  loadAll(): void {
    this.catalogSearchCriteriaFacade
      .getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.Transport)
      .subscribe((searchCriteria: TransportCatalogSearchCriteria) => {
        const { viewMode, ...rest } = searchCriteria;

        if (viewMode === ListViewMode.TransportOrder) {
          this.activeState$.next(this.transportOrderCatalogFacade.listDto$);
          this.transportOrderCatalogFacade.load(rest);
        } else {
          this.activeState$.next(this.loadCatalogFacade.listDto$);
          this.loadCatalogFacade.load(rest);
        }
      });
  }

  setInitialState(): void {
    this.transportOrderCatalogFacade.setInitialState();
    this.loadCatalogFacade.setInitialState();
  }
}
